import React from 'react';
import Navbar from '../components/layout/navbar/Navbar';
import ContactGreeting from '../components/layout/contact/ContactGreeting';
import Footer from '../components/layout/footer/Footer';

const Contact = () => {
  return (
    <div>
      <Navbar />
      <ContactGreeting />
      <Footer />
    </div>
  );
};

export default Contact;
